export default "__VITE_ASSET__B3LzX_kN__"